import React from "react";

export default function Footer() {
  return (
    <div>
      <footer>
        Coded by Kennedy
        <a href="https://github.com/kennedybailey/Weather-project">
          opensourced on Git
        </a>
        , hosted by Netlify
      </footer>
    </div>
  );
}
